// extracted by mini-css-extract-plugin
export var sliderRange = "_qc-2";
export var sliderRoot = "_qc-0";
export var sliderThumb = "_qc-3";
export var sliderTrack = "_qc-1";